import React from "react"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import Anime from "react-anime"

export default function HeroInner({
  heroImage = null,
  heroMobileImage = null,
  heroTitle = null,
  breadcrumbSecondaryItem = null,
  breadcrumbSecondaryItemUrl = null,
  ...rest
}) {
  // useLocation is populated during SSR (Gatsby renders each page with its own
  // ServerLocation) so this is correct in the static build, not just the browser.
  const { pathname } = useLocation()
  const stripSlash = p => (p && p !== "/" ? p.replace(/\/$/, "") : p)
  // The secondary crumb points at the section's first child page. When we're
  // already on that page the link would just point to itself, so render it as
  // plain text there and only link it from the section's other pages.
  const secondaryIsCurrent =
    breadcrumbSecondaryItemUrl &&
    stripSlash(breadcrumbSecondaryItemUrl) === stripSlash(pathname)
  let videoComment =
    '<!--[if IE 9]><video style="display:none;"><![endif]--><source media="(max-width: 767px)" sizes="33vw" srcset="' +
    heroMobileImage +
    ' 2x" /><source media="(min-width: 768px)" sizes="100vw" srcset="' +
    heroImage +
    ' 2x" /><!--[if IE 9]></video><![endif]--><img class="image-cover apricus-banner-image" sizes="(min-width: 601px) 33vw, 100vw" srcset="' +
    heroMobileImage +
    " 767w, " +
    heroImage +
    ' 1200w" alt="' +
    heroTitle +
    '" />'

  return (
    <>
      <div
        class="o-content-slider"
        role="region"
        aria-label={heroTitle ? heroTitle + " banner" : "Page banner"}
      >
        <div id="heroslider" class="o-media-hero_inner relative">
          <div class="o-media-slider">
            <div class="o-media-flexslider js-flexslider">
              {/* Single static banner "slide": role="presentation" strips the
                  list semantics (there is no list of items here) so it is not
                  reported as an unnecessary list, while keeping the .slides/.slide
                  classes the layout CSS relies on (WCAG 1.3.1). */}
              <ul class="o-media-slides slides" role="presentation">
                <li class="o-media-slide slide slide-1" role="presentation">
                  <span class="hero--overlay"></span>
                  <Anime
                    easing="easeOutExpo"
                    duration={1200}
                    direction="alternate"
                    loop={false}
                    delay={(el, index) => index * 240}
                    translateX="0rem"
                    scale={[1.6, 1]}
                    opacity={[0, 1]}
                  >
                    <picture dangerouslySetInnerHTML={{ __html: videoComment }}></picture>
                  </Anime>
                  <div class="o-media-hero_overlay">
                    <div class="o-media-hero_caption">
                      <div class="o-media-hero_caption_balance">
                        <div class="container">
                          <div class="o-cards-view__container o-cards-view__container-xs">
                            <div class="o-cards-view__info apricus-main-title">
                              <Anime
                                easing="easeOutExpo"
                                duration={1500}
                                direction="alternate"
                                loop={false}
                                delay={(el, index) => index * 30}
                                translateX={[-90, 0]}
                                opacity={[0, 1]}
                              >
                                <h1 class="o-cards-view__info--heading o-cards-view__info--heading-xs">
                                  {heroTitle}
                                </h1>
                              </Anime>
                              <nav aria-label="Breadcrumb">
                                <ol class="breadcrumb">
                                  <li>
                                    <Link to="/">Home</Link>
                                  </li>
                                  {breadcrumbSecondaryItem && (
                                    <li class="">
                                      {breadcrumbSecondaryItemUrl && !secondaryIsCurrent ? (
                                        <Link to={breadcrumbSecondaryItemUrl}>
                                          {breadcrumbSecondaryItem}
                                        </Link>
                                      ) : (
                                        breadcrumbSecondaryItem
                                      )}
                                    </li>
                                  )}
                                  <li class="active" aria-current="page">
                                    {heroTitle}
                                  </li>
                                </ol>
                              </nav>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </>
  )
}
